import { render, staticRenderFns } from "./AnnotationsContainer.vue?vue&type=template&id=1b4a5d57&scoped=true"
import script from "./AnnotationsContainer.vue?vue&type=script&lang=js"
export * from "./AnnotationsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4a5d57",
  null
  
)

export default component.exports